module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('instamapsBreadcrumbs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasBreadcrumbs),
      expression: "hasBreadcrumbs"
    }],
    attrs: {
      "title": _vm.$t('title')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('form', {
    staticClass: "my-form-signin",
    attrs: {
      "id": "frm_login"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('section', [_c('h4', {
    staticClass: "form-signin-heading"
  }, [_vm._v(_vm._s(_vm.$t('hasOblidat')))]), _vm._v(" "), _c('fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control my-border",
    attrs: {
      "id": "email",
      "name": "email",
      "placeholder": _vm.$t('emailPlaceholder'),
      "autofocus": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "centered validationErrorMsg"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('emailValidation')))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg bt-sessio btn-block",
    attrs: {
      "id": "login_button",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.recuperar()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('recuperarPssw')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('notaRecuperarPsw'))), _c('a', {
    attrs: {
      "href": "http://www.icgc.cat/Registre/Recordar-l-usuari-o-la-contrasenya",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('enllacRecuperarPsw')))])])])])]), _vm._v(" "), _c('instamapsMessageModal', {
    attrs: {
      "delay": 10,
      "isError": _vm.modalIsError,
      "isLoaded": _vm.modalIsLoaded,
      "title": _vm.modalTitle,
      "message": _vm.modalMessage
    },
    on: {
      "loaded": _vm.loaded
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92fadf9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/oblidat/oblidat.vue
// module id = 316
// module chunks = 0